
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","aria-hidden":"true","focusable":"false"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#svg-icon-money__clip0_3826_144570)"}},[_c('path',{attrs:{"d":"M7.997 13.42L.151 9.523a.27.27 0 01.021-.494L12.776 4.02a.28.28 0 01.227.009l7.846 3.9a.27.27 0 01-.021.493L8.224 13.43a.28.28 0 01-.227-.009v0z","stroke":"currentColor","stroke-miterlimit":"10"}}),_c('path',{attrs:{"d":"M0 11.77l7.922 3.963L21 10.5v1.123l-12.796 5.12a.795.795 0 01-.65-.027L0 12.935v-1.167zm8.027 4.016z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M12.325 9.67c-1.268.305-2.536.305-3.677-.152-1.014-.457-1.014-1.067.127-1.523 1.268-.305 2.536-.305 3.677.152 1.014.457.888 1.066-.127 1.523z","stroke":"currentColor","stroke-miterlimit":"10"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"svg-icon-money__clip0_3826_144570"}},[_c('path',{attrs:{"fill":"currentColor","d":"M0 0h21v20H0z"}})])])])
          )
        }
      }
    